import { useState, useEffect } from 'react';
import { useCooperativeId } from 'hooks';
import { AloneEventInformation } from 'models';
import services, { fetchTranslations } from 'services';
import { eventInformationFields } from 'configs';
import { extractKeysFromFieldItem } from 'utils';
import { values } from 'lodash';

import { EventInformationDetails } from 'components';

type EventInformationProps = {
  id: string | null;
  board?: boolean;
};

type EventInformationState = {
  eventInformation: AloneEventInformation | null;
  loading: boolean;
  error: boolean;
};

const EventInformation = ({ id, board = false }: EventInformationProps) => {
  const coopId = useCooperativeId();

  const [state, setState] = useState<EventInformationState>({
    eventInformation: null,
    loading: true,
    error: false,
  });

  useEffect(() => {
    let mounted = true;

    (async function () {
      if (coopId && id) {
        try {
          const keys = extractKeysFromFieldItem(values(eventInformationFields));

          await fetchTranslations(keys);
          const eventInformation: AloneEventInformation =
            await fetchEventInformation(coopId, id);

          if (mounted) {
            setState((prevState) => ({
              ...prevState,
              eventInformation,
              loading: false,
            }));
          }
        } catch (err) {
          if (mounted) {
            setState((prevState) => ({
              ...prevState,
              loading: false,
              error: true,
            }));
          }
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [id, coopId]);

  const fetchEventInformation = async (coopId: string, eventId: string) => {
    const url = board
      ? `/api/cooperatives/${coopId}/events-information/${eventId}`
      : `/api/user/cooperatives/${coopId}/events-information/${eventId}`;
    const eventInformation: AloneEventInformation = (await services.get(url))
      .data.Data;

    return eventInformation;
  };

  return (
    <EventInformationDetails
      board={board}
      error={state.error}
      eventInformation={state.eventInformation}
      loading={state.loading}
    />
  );
};

export default EventInformation;
